import { render, staticRenderFns } from "./DaSelect.vue?vue&type=template&id=41512f88&"
import script from "./DaSelect.vue?vue&type=script&lang=js&"
export * from "./DaSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports